const AUTO_COMPLET_TYPE = {
    signle: '',
    multiple: 'multiple'
}

export default AUTO_COMPLET_TYPE